// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const MasterAssetService = {};

MasterAssetService.getCountryId = function (data) {
  return lossClient({
    url: `/reference/countryid`,
    method: "get",
  });
};

MasterAssetService.getOriginationId = function (data) {
  return lossClient({
    url: `/reference/origination`,
    method: "get",
  });
};

MasterAssetService.getMasterAssetAttribute = function (data) {
  return lossClient({
    url: `/reference/masterassetattribute`,
    method: "get",
  });
};

MasterAssetService.getIsNewAsset = function (data) {
  return lossClient({
    url: `/reference/isnewasset`,
    method: "get",
  });
};

MasterAssetService.getIsUsedAsset = function (data) {
  return lossClient({
    url: `/reference/isusedasset`,
    method: "get",
  });
};
MasterAssetService.getDocumentType = function (data) {
  return lossClient({
    url: `/reference/documentType`,
    method: "get",
  });
};
MasterAssetService.getDocumentStatus = function (data) {
  return lossClient({
    url: `/reference/documentStatus`,
    method: "get",
  });
};
MasterAssetService.getCustomerType = function (data) {
  return lossClient({
    url: `/reference/customertype`,
    method: "get",
  });
};
MasterAssetService.getIsNoRequired = function (data) {
  return lossClient({
    url: `/reference/isnorequired`,
    method: "get",
  });
};

export default MasterAssetService;
